import NextLink from 'next/link';

import Button from 'shopper/components/Button';

import { toLastCommentsLink } from 'lib/links';
import placeholder from 'lib/placeholder';

const CommentsButton = () => (
  <NextLink href={toLastCommentsLink()} prefetch={false} passHref>
    <Button
      as="a"
      data-test-selector="comments-tab"
      size="size4"
      type="neutral-ghost"
    >
      {placeholder('actions.seeLastComments')}
    </Button>
  </NextLink>
);

export default CommentsButton;
